import { createFileRoute } from "@tanstack/react-router";
import { IncidentDetail } from "@/components/incidents/incident-detail";
import {
  employeeDirectoryQuery,
  incidentAttachmentsQuery,
  incidentDocumentsQuery,
  incidentNotesQuery,
  incidentQuery,
  warm,
} from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/incidents/$id")({
  // A head start on every panel; the page renders its own skeleton.
  loader: ({ context, params }) => {
    const qc = context.queryClient;
    warm(qc.ensureQueryData(incidentQuery(params.id)));
    warm(qc.ensureQueryData(incidentNotesQuery(params.id)));
    warm(qc.ensureQueryData(incidentAttachmentsQuery(params.id)));
    warm(qc.ensureQueryData(incidentDocumentsQuery(params.id)));
    warm(qc.ensureQueryData(employeeDirectoryQuery));
  },
  component: IncidentDetailPage,
});

function IncidentDetailPage() {
  const { id } = Route.useParams();
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-4xl">
        <IncidentDetail id={id} />
      </div>
    </main>
  );
}
